import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { navConfig } from "constants/index";

class Navigation extends Component {
  state = {
    navActiveClass: ""
  };

  componentDidMount = () => {
    document.addEventListener("mousedown", this.handleClickOutsidePopup);
  };

  handleClickOutsidePopup = event => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.closePopup();
    }
  };
  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  closePopup = () => {
    this.setState({ popupActiveClass: "" });
  };

  handleCloseClick = () => {
    this.closePopup();
  };

  handlePopupClick = () => {
    const { popupActiveClass } = this.state;
    popupActiveClass === ""
      ? this.setState({ popupActiveClass: "uiPopup--active" })
      : this.closePopup();
  };
  render() {
    return (
      <div className={`uiPopup navPopup ${this.state.popupActiveClass}`}>
        <button onClick={this.handlePopupClick} className="uiPopup__trigger">
          <i className="fas fa-bars" />
        </button>
        <div
          className="uiPopup__popup uiPopup__popup--left navPopup__popup"
          ref={this.setWrapperRef}
        >
          <button
            className="uiPopup__closeButton uiPopup__closeButton--right"
            onClick={this.handleCloseClick}
          >
            {" "}
            <i className="fas fa-times" />
          </button>
          <nav className="navPopup__navigation">
            <h2 className="navPopup__title">Categories</h2>
            <ul className="categoryList">
              {navConfig.map(nav => (
                <li key={nav.id}>
                  <NavLink
                    className="categoryList__link"
                    activeClassName="categoryList__link--current"
                    onClick={this.closePopup}
                    to={nav.navLink}
                  >
                    {nav.navTitle}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Header/components/Navigation.jsx